import React from 'react';
import { Redirect } from '../components/Router';
const TeamNoIdRedirect = () => /*#__PURE__*/React.createElement(Redirect, {
  to: "/search"
});
export default TeamNoIdRedirect;